angular.module('app').component('objectRepairs', {
    templateUrl: 'js/components/object-repairs/index.html',
    controller: ObjectRepairsController,
    controllerAs: '$or',
    bindings: {
        object: '=',
    },
});

ObjectRepairsController.$inject = ['$ngConfirm', '$translate', '$scope', 'toaster', '$http', '$window'];

function ObjectRepairsController($ngConfirm, $translate, $scope, toaster, $http, $window) {
    var $ctrl = this;

    $ctrl.modalData = {
        form: {
            date: moment.utc(),
            repairName: '',
            counter: '',
            comment: ''
        },
        data: {
            repairs: [],
            expanded: false,
            isEditMode: false,
            isLoading: false
        },
        afterFormAction: function() {
            $ctrl.loadData(false);
            $ctrl.modalData.resetForm();
        },
        resetForm: function () {
            $ctrl.modalData.form = {
                date: moment.utc(),
                repairName: '',
                counter: '',
                comment: ''
            };
        },
        cancelEditMode: function () {
            $ctrl.modalData.data.isEditMode = false;
            $ctrl.modalData.resetForm();
        },
        toggleExpandedForm: function() {
            $ctrl.modalData.data.expanded = !$ctrl.modalData.data.expanded;
        },
        remove: function (id) {
            $http.delete('/api/repairs/'+id).then(
                function () {
                    $ctrl.modalData.afterFormAction(false);

                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant(
                            'general.toastr.success.form.action.delete'
                        )
                    );
                },
                function () {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant(
                            'general.toastr.error.form.action.default'
                        )
                    );
                }
            );
        },
        create: function(form) {
            if(form.$invalid) {
                toaster.pop({
                    type: 'error',
                    title: $translate.instant(
                        'general.toastr.error.header'
                    ),
                    body: $translate.instant(
                        'error.InvalidForm'
                    ),
                });

                return
            }

            var payload = Object.assign({}, $ctrl.modalData.form);
            payload.objectId = $ctrl.object.id;

            $http.post('/api/repairs', payload).then(
                function () {
                    form.repairName.$touched = false;
                    $ctrl.modalData.afterFormAction(false);

                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant(
                            'general.toastr.success.form.action.save'
                        )
                    );
                },
                function () {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant(
                            'general.toastr.error.form.action.default'
                        )
                    );
                }
            );
        },
        gotToEditMode: function (repair) {
            $ctrl.modalData.resetForm();
            $ctrl.modalData.data.isEditMode = true;
            $ctrl.modalData.data.expanded = true;

            $ctrl.modalData.form = {
                date: moment.utc(repair.date),
                repairName: repair.repairName,
                counter: Number(repair.counter),
                comment: repair.comment,
                id: repair.id
            };
        },
        update: function(form) {
            if(form.$invalid) {
                toaster.pop({
                    type: 'error',
                    title: $translate.instant(
                        'general.toastr.error.header'
                    ),
                    body: $translate.instant(
                        'error.InvalidForm'
                    ),
                });

                return
            }
            var payload = Object.assign({}, $ctrl.modalData.form);
            payload.objectId = $ctrl.object.id;

            $http.put('/api/repairs/' + $ctrl.modalData.form.id, payload).then(
                function () {
                    form.repairName.$touched = false;
                    $ctrl.modalData.afterFormAction(false);
                    $ctrl.modalData.data.isEditMode = false;

                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant(
                            'general.toastr.success.form.action.update'
                        )
                    );
                },
                function () {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant(
                            'general.toastr.error.form.action.default'
                        )
                    );
                }
            );
        },
        download: function () {
            $ctrl.modalData.data.isLoading = true;

            var scroller =  angular.element('.ng-confirm-scrollpane');
            scroller.css('overflow', 'hidden');

            $http.get('/api/repairs/download/'+$ctrl.object.id).then(
                function (data) {
                    $ctrl.modalData.data.isLoading = false;
                    scroller.css('overflow', 'auto');

                    $window.open(
                        data.data.data,
                        '_blank'
                    );
                },
                function () {
                    $ctrl.modalData.data.isLoading = false;
                    scroller.css('overflow', 'auto');

                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant(
                            'general.toastr.error.form.action.default'
                        )
                    );
                }
            );
        }
    }

    $ctrl.openRepairFormModal = function () {
        var $isolated = $scope.$new(true);
        $isolated.modalData = $ctrl.modalData;

        $ngConfirm({
            title: $translate.instant('repairs.header.title') + ' ' + this.object.number + ' (' + this.object.comment + ')',
            contentUrl: 'js/components/object-repairs/modals/list.html',
            animation: 'rotate',
            theme: 'supervan',
            columnClass: 'lxl',
            icon: 'pe-7s-car',
            scope: $isolated,
            buttons: {
                no: {
                    text: $translate.instant('general.confirm.save.cancel'),
                    btnClass: 'btn-info',
                },
            }
        });
    };

    $ctrl.openRepairHistoryModal =  function() {
        $ctrl.loadData(true);
    }

    $ctrl.loadData = function (openModal) {
        $http.get('/api/repairs/object/'+this.object.id).then(
            function (data) {
                $ctrl.modalData.data.repairs = data.data.data;

                if(openModal) {
                    $ctrl.openRepairFormModal();
                }
            },
            function () {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant(
                        'general.toastr.error.form.action.default'
                    )
                );
            }
        );
    }

    $ctrl.$onInit = function () {
        $ctrl.object = this.object;
    };
}
